<template>
	<div id="framework">
		<!-- 侧边栏 -->
		<div id="sidebar">
			<div id="logo">
				<!-- logo -->
				<el-avatar v-show="isCollapse" shape="square" :size="48" src="../../images/logo.png"></el-avatar>
				<span v-show="!isCollapse"><i class="el-icon-notebook-1"></i> 课本征订系统</span>
			</div>
			<el-menu class="el-menu-vertical-demo" style="border-right: 1px" @select="handleSelect" :collapse="isCollapse" :collapse-transition="true"
			 background-color="#20222a" text-color="#bdbdc0"  :default-active="this.$route.path">
       	<el-menu-item index="1" @click="handleCollapse">
          <i class="el-icon-s-fold"></i>
          <span slot="title">折叠</span>
				</el-menu-item>
        <el-menu-item  v-for="item in menuData" :key="item.path" v-show="judgeRole(item.role)" :index="item.path">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
			</el-menu>
			</div>
			<div id="right" :class="{ 'dashboard-right': isDashboard }">
				<!-- 顶部栏 -->
				<div id="topbar" v-if="!isBookTotal">
	        <div class="top-bar" >
	          <span class="bar-tag" v-if="isAdmin">管理员: {{ userInfo.username }}</span>
	          <span class="bar-tag" v-else>学校名称: {{ userInfo.username }}</span>
					<div class="log-out" @click="handleLogout">
            <span class="bar-tag"><span class="el-icon-back"></span> 退出</span>
					</div>
				</div>
			</div>
				<div id="mainOut" :class="{ 'dashboard-main-out': isDashboard }" :style="isBookTotal ? {height: '100%', overflow: 'hidden'} : {}">
					<!-- 主要内容区 -->
					<div id="main" :class="['panel', { 'dashboard-main-panel': isDashboard }]">
					<slot></slot>
					<el-backtop target="#mainOut">
						<span class="backTop el-icon-caret-top"></span>
					</el-backtop>
				</div>
				<!--页脚-->
				<div id="footer" class="panel"></div>
			</div>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'framework',
  data () {
    return {
      isCollapse: false,
      menuData: [
        {
          name: '数据大盘',
          icon: 'el-icon-data-analysis',
          path: '/dashboard',
          role: '1'
        },
        {
          name: '数据填报',
          icon: 'el-icon-s-home',
          path: '/mainpage',
          role: '0'
        },
        {
          name: '订单查看',
          icon: 'el-icon-notebook-2',
          path: '/watchTotal',
          role: '0'
        },
        {
          name: '补订查看',
          icon: 'el-icon-document',
          path: '/fixRecord',
          role: '0'
        },
        {
          name: '汇总导出',
          icon: 'el-icon-download',
          path: '/bookExport',
          role: '0'
        },
        {
          name: '修改密码',
          icon: 'el-icon-key',
          path: '/changePassword',
          role: '0'
        },
        {
          name: '信息维护',
          icon: 'el-icon-office-building',
          path: '/schoolProfile',
          role: '0'
        },
        {
          name: '用户管理',
          icon: 'el-icon-user',
          path: '/schoolManager',
          role: '1'
        },
        {
          name: '白名单管理',
          icon: 'el-icon-message',
          path: '/whiteList',
          role: '1'
        },
        {
          name: '当前学期设置',
          icon: 'el-icon-collection-tag',
          path: '/currentTermSet',
          role: '1'
        },
        {
          name: '征订时间设置',
          icon: 'el-icon-time',
          path: '/timeSet',
          role: '1'
        },
        {
          name: '书单导入',
          icon: 'el-icon-upload',
          path: '/bookInput',
          role: '1'
        },
        {
          name: '未填报统计',
          icon: 'el-icon-school',
          path: '/unfillStatistics',
          role: '1'
        },
        {
          name: '初始订单查看',
          icon: 'el-icon-box',
          path: '/watchSub',
          role: '1'
        },
        {
          name: '补订审核',
          icon: 'el-icon-document-checked',
          path: '/fixAudit',
          role: '1'
        },
        {
          name: '退订管理',
          icon: 'el-icon-edit',
          path: '/bookRefuse',
          role: '1'
        },
        {
          name: '书价核定',
          icon: 'el-icon-price-tag',
          path: '/priceCheck',
          role: '1'
        },
        {
          name: '书籍维护',
          icon: 'el-icon-edit-outline',
          path: '/bookManage',
          role: '1'
        },
        {
          name: '数据导出',
          icon: 'el-icon-download',
          path: '/exportData',
          role: '1'
        }
      ]
    }
  },
  mounted () {
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    isBookTotal () {
      return this.$route.path === '/bookTotal'
    },
    isDashboard () {
      return this.$route.path === '/dashboard'
    },
    isAdmin () {
      return this.$store.state.userInfo.userType === '1'
    }
  },
  methods: {
    judgeRole (roleType) {
      return this.$store.state.userInfo.userType == roleType
    },
    handleLogout () {
      const url = '/api/' + (this.isAdmin ? 'admin' : 'user') + '/auth/logout'
      request.post(url).then(() => {
        this.$router.push('/login')
        this.$store.state.userInfo = {}
      })
    },
    handleCollapse () {
      // 切换显示与展示
      this.isCollapse = !this.isCollapse
    },
    handleSelect (key, keyPath) {
      if (key == 1) {
        return
      }
      const path = keyPath[keyPath.length - 1]
      // 退出登录
      if (path === '/logout') {
        this.$store.commit('setUser', null)
        this.$router.push('/login')
      } else {
        // 跳转到指定页面
        this.$router.push(path)
      }
    },
    toIndex () {
      this.$router.push('/')
    }

  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
  .top-bar {
    height: 60px;
    width: 100%;
    background: white;
  }
  .bar-tag {
    line-height: 60px;
    font-size: 16px;
    padding: 30px;
  }
  .log-out {
    float: right;
    cursor: pointer;
    color: #909399;
  }
  .log-out:hover {
    background: #ecf5ff;
    color: black;
  }
	.el-avatar {
		background-color: rgba(0, 0, 0, 0);
	}

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

	#framework {
		width: 100%;
		height: 100%;
		display: flex;

		#sidebar {
			height: 100%;
			background: #20222a;
			overflow: auto;

			#logo {
				color: #bdbdc0;
				height: 60px;

				.el-menu {
					border: 0px;
				}

				span {
					background-color: rgba(0, 0, 0, 0);
					display: block;
					text-align: center;
					position: relative;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

			#right {
				flex: 1;
				background: #f2f2f2;
				overflow: hidden;

				#topbar {
					position: sticky;
					top: 0px;
					width: 100%;
				}

				#mainOut {
					height: calc(~"100% - 60px");
					padding: 0;
					overflow-y: auto;

					.panel {
						background: white;
						border-radius: 0;
					}

					#main {
						min-height: 100%;
						height: auto;
						// height: 1500px;
						.backTop {
							font-size: 32px;
							color: #409eff;
						}
					}

					#footer {
						display: none;
					}
				}

				&.dashboard-right {
					.bar-tag {
						padding-left: 20px;
						padding-right: 20px;
					}

					#mainOut.dashboard-main-out {
						#main.dashboard-main-panel {
							background: transparent;
						}
					}
				}
			}
		}
	</style>
